import React from "react";
import { XIcon } from "lucide-react";
import { pains } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function PainSection() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-106" data-mp="2uy5mizx0gxyj">
      <SectionHeading eyebrow="LA RÉALITÉ DE L'ENSEIGNEMENT DE LA GUITARE" title={<>Combien de temps allez-vous encore préparer chaque cours <span className="text-gold" data-id="element-108" data-mp="2l7azvufurwck">de zéro ?</span></>} data-id="element-107" data-mp="2v0i2j7j7ky8y" />
      <ul className="mx-auto mt-10 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-109" data-mp="2pz2hvgky0tr3">
        {pains.map(p => <li key={p} className="flex gap-3 rounded-xl border border-line bg-ink p-4 text-mute" data-id="element-110" data-mp="2bag2xfz8a40e">
            <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-ribbon" aria-hidden data-id="element-111" data-mp="2g8zqtlxdtpve" />
            {p}
          </li>)}
      </ul>
      <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-lg italic text-cream sm:text-xl" data-id="element-112" data-mp="22aj80wm8w8ww">
        Votre temps devrait servir à enseigner, pas à mettre en page des fiches.
      </p>
    </section>;
}